import { ConfigurationDto } from 'lib_api/lib/api/gen';

import { FetchDataResult } from 'components/WrappedComponents/Table/types';

export function computeNewData(
  oldData: FetchDataResult<ConfigurationDto>,
  mutationResult: ConfigurationDto,
): FetchDataResult<ConfigurationDto> {
  const updatedConfigurations = oldData.data.map(config =>
    config.idCorrelation === mutationResult.idCorrelation
      ? mutationResult
      : config,
  );

  return {
    ...oldData,
    data: updatedConfigurations,
  };
}
